import Mission from "../../../../contents/handbook/small-teams/infrastructure/mission.mdx";
import Objectives from "../../../../contents/handbook/small-teams/infrastructure/objectives.mdx";
import * as React from 'react';
export default {
  Mission,
  Objectives,
  React
};